// @ts-nocheck
import React, { useContext } from "react";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins/spacing";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import translate from "@insite/client-framework/Translate";
import Link from "@insite/mobius/Link";
import getColor from "@insite/mobius/utilities/getColor";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";

export interface ProductDetailsBundleStyles {
    wrapper?: InjectableCss;
    configSectionWrapper?: InjectableCss;
    configSectionLabel?: TypographyPresentationProps;
    sectionOptionText?: TypographyPresentationProps;
    list?: InjectableCss;
    item?: InjectableCss;
}

export const productDetailsBundleStyles: ProductDetailsBundleStyles = {
    wrapper: {
        css: css`
            ${x =>
                spacingStyles(
                    x.theme.design.product.detail.contentSpacing,
                    x.theme.design.product.detail.contentSpacing,
                )};
            border-top: 1px solid ${getColor("common.accent")};
            padding-top: ${pxToRem(8)};
            width: 100%;
        `,
    },
    configSectionWrapper: {
        css: css`
            ${spacingStyles(pxToRem(10), pxToRem(10))};
        `,
    },
    configSectionLabel: {
        forwardAs: "h2",
        css: css`
            font-size: ${pxToRem(20)};
            font-weight: ${x => x.theme.design.typography.weight.bold};
            margin-top: ${pxToRem(16)};
        `,
    },
    list: {
        css: css`
            padding-left: 0;
            display: flex;
            flex-direction: column;
            gap: ${pxToRem(2)};
        `,
    },
    item: {
        css: css`
            font-size: ${pxToRem(14)};
        `,
    },
};

const styles = productDetailsBundleStyles;

const ProductDetailsBundle = () => {
    const { product } = useContext(ProductContext);
    const configuration = useAppSelector(state => getProductState(state, product.id).value?.detail?.configuration);

    if (
        !configuration ||
        !configuration.isKit ||
        !configuration.configSections ||
        configuration.configSections.length === 0
    ) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.configSectionLabel}>{translate("Products Included in Bundle")}</Typography>
            {configuration.configSections.map(
                configSection =>
                    !!configSection.sectionOptions?.length && (
                        <StyledWrapper {...styles.configSectionWrapper} key={configSection.id}>
                            <StyledWrapper as="ul" {...styles.list}>
                                {configSection.sectionOptions?.map(sectionOption => (
                                    <StyledWrapper as="li" key={sectionOption.id} {...styles.item}>
                                        <span>{sectionOption.quantity}x </span>
                                        <Link href={sectionOption?.canonicalUrl}>{sectionOption.description}</Link>
                                    </StyledWrapper>
                                ))}
                            </StyledWrapper>
                        </StyledWrapper>
                    ),
            )}
        </StyledWrapper>
    );
};

export default ProductDetailsBundle;
